import { ReactComponent as CheckedBoxIcon } from './checked-box.svg'
export default CheckedBoxIcon
